import styled from "@emotion/styled";

import { fontRoboto } from "shared/lib/styles";

import { BaseImage } from "scmp-app/components/common/base-image";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  inline-size: 100%;
  block-size: 100%;

  cursor: pointer;
`;

export const StyledImage = styled(BaseImage)`
  inline-size: 100%;
  block-size: auto;

  border-radius: 12px;

  object-fit: cover;

  aspect-ratio: 9/16;
`;

export const Headline = styled.div`
  color: #000000;
  font-weight: 700;
  font-size: 14px;
  font-family: ${fontRoboto};
  font-style: normal;
  line-height: 130%;
`;
